<template>
    <tr
        v-if="isBeingEdited"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ role.parameterValue.value }}
        </td>
        <td class="kgr-table__cell">
            <div class="form-widget without-label date-picker">
                <kgr-date-picker v-model="editRole.from" />
            </div>
        </td>
        <td class="kgr-table__cell">
            <div
                class="form-widget without-label date-picker"
                :class="{ invalid: !editRole.isValidDateRange() }"
            >
                <kgr-date-picker v-model="editRole.to" />
            </div>
        </td>
        <td class="kgr-table__cell">
            {{ departmentName }}
        </td>
        <td class="kgr-table__cell">
            {{ teamName }}
        </td>
        <td class="kgr-table__cell">
            <div class="form-widget without-label date-picker">
                <textarea
                    v-model.trim="editRole.notice"
                    class="kgr-input"
                    rows="3"
                ></textarea>
            </div>
        </td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <kgr-icon-edit
                :size="15"
                disabled
                class="kgr-table__action"
            />
            <kgr-icon-delete
                class="kgr-table__action"
                @click="$emit('remove')"
            />
        </td>
    </tr>
</template>

<script>
import DatePicker from '../../common/form/picker/DatePicker';
import IconDelete from '../../common/icon/IconDelete';
import IconEdit from '../../common/icon/IconEdit';
import MemberRole from '../../../js/dto/MemberRole';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
    },
    props: {
        role: {
            type: MemberRole,
            required: true
        },
        editRoles: {
            type: Array,
            required: true
        },
    },
    computed: {
        isBeingEdited() {
            return this.editIndex !== -1;
        },
        editIndex() {
            return this.editRoles.map(editRole => editRole.id).indexOf(this.role.id);
        },
        editRole() {
            return this.editRoles[this.editIndex];
        },
        departmentName() {
            return this.role.department ? this.role.department.name : '';
        },
        teamName() {
            return this.role.team ? this.role.team.name : '';
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .kgr-table__cell  {
        vertical-align: top;
    }

    .date-picker {
        border: 1px solid transparent;

        &.invalid {
            border: 1px solid #F44336;
        }
    }
</style>
